module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1041-3873c0d2bcdb1e8ae8fae03f9f3da25b.png";